/*
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 10:12:53
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-08-15 09:47:47
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
Vue.use(VueRouter)

// 移动端所需参数
const token = store.state.app.token || 'eb29359d070ffea45e5a534e3f48dc75',
  baseId = store.state.app.baseId || 'ff58de84-4b03-46cf-9fbf-68b2fdab9f3e',
  orgId = store.state.app.orgId || 'aebd3bb6-f54e-4cfd-9120-c6bc6b49ed37',
  type = store.state.app.type || 'month',
  dayYm = store.state.app.dayYm || true,
  monthYm = store.state.app.monthYm || true;

// 首页用重定向的方式来进行适配的方案：
const redirectPath = /Android |webos | iphone| iPod| BlackBerry| liPad/i.test(navigator.userAgent) ?
  'm_index' :
  '/yc';
import {
  constantRoutes,
  subRoutes
} from '../../router/pc/index';
// 默认路由
const routes = [{
    path: "/",
    redirect: redirectPath,
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import("../../views/pc/login.vue"),
    meta: {
      title: '临时登录'
    },
  },
]
const newRoutes = routes.concat(constantRoutes).concat(subRoutes); //子桌面路由拼接开发调试

const createRouter = () => new VueRouter({
  mode: 'history',
  base: 'uyu-desktop',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: newRoutes
})

const router = createRouter();

// 重置路由表
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
router.beforeEach((to, from, next) => {

  if (/Android|webOS|iPhone|iPod|BlackBerry|liPad/i.test(navigator.userAgent)) {
    // alert('转移动端页面');
    const href = window.location.href;
    if (href.indexOf('/month/') > -1 || href.indexOf('/day/') > -1) {
      window.location.href = `/uyu-desktop/mobile.html?token=${token}&baseId=${baseId}&orgId=${orgId}&type=${href.indexOf('/month/') > -1 ? 'month':'day'}&dayYm=${dayYm}&monthYm=${monthYm}`;
    } else {
      window.location.href = `/uyu-desktop/mobile.html?token=${token}&baseId=${baseId}&orgId=${orgId}&type=${type}&dayYm=${dayYm}&monthYm=${monthYm}`;
    }
    return
  }
  next()
})

export default router